import { IS_WEB } from "./Config";

const PAYMENT_HISTORY_KEY = 'payment_history';

export const SessionStorage = {
  getPaymentHistory: () => {
    if (!IS_WEB) return [];
    const history = localStorage.getItem(PAYMENT_HISTORY_KEY);
    return history ? JSON.parse(history) : [];
  },

  addPaymentToHistory: (payment) => {
    if (!IS_WEB) return;
    const history = SessionStorage.getPaymentHistory();
    history.unshift({
      ...payment,
      timestamp: new Date().toISOString()
    });
    localStorage.setItem(PAYMENT_HISTORY_KEY, JSON.stringify(history));
  },

  clearPaymentHistory: () => {
    if (!IS_WEB) return;
    localStorage.removeItem(PAYMENT_HISTORY_KEY);
  }
}; 